import { createContext, useContext } from "react";

/**
 * The edge the knowledge base sidebar should open from for any
 * `KnowledgeBaseTrigger` rendered within this subtree.
 *
 * Defaults to "right". The filter sidebar (`FilterSheetFrame`) overrides it to
 * "left" so that help opened while annotating filters slides in beside the
 * filter sheet instead of covering it.
 */
const KnowledgeBaseSideContext = createContext<"left" | "right">("right");

export const KnowledgeBaseSideProvider = KnowledgeBaseSideContext.Provider;

export const useKnowledgeBaseSide = () => useContext(KnowledgeBaseSideContext);
